import React from 'react';
import autoBind from 'react-autobind';
import { Skeleton } from '@material-ui/lab';
import { Row, Col } from 'react-bootstrap';

class Container extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
    autoBind(this);
  }

  render() {
    let skeleton = [];

    skeleton.push(
      <>
        <Row className={'d-flex justify-content-between'}>
          <Col lg={2}>
            <Skeleton height={60} />
          </Col>
          <Col lg={3}>
            <Skeleton height={60} />
          </Col>
        </Row>
      </>
    );
    for (let index = 0; index < 7; index++) {
      skeleton.push(
        <>
          <Skeleton height={60} />
        </>
      );
    }
    skeleton.push(
      <>
        <Row className={'d-flex justify-content-between'}>
          <Col lg={4}>
            <Skeleton height={60} />
          </Col>
          <Col lg={2}>
            <Skeleton height={60} />
          </Col>
        </Row>
      </>
    );
    return <>{skeleton}</>;
  }
}

export default Container;
